<template>
    <div>
        <el-card class="f-full">
            <div slot="header">
                <div class="flex align-middle justify-between">
                    <span class="my-auto font-medium mx-2 main-text-color" :class="actionsWithSchedule ? 'w-1/3' : 'w-2/5'">{{ get(data, 'ReportTriggerName', '') }}</span>
                    <div
                        class="flex items-center"
                        :class="[
                            actionsWithSchedule ? 'w-1/3 justify-start' : 'w-3/5 justify-end',
                            $rtl.isRTL ? 'text-right' : ''
                        ]"
                    >
                        <span v-if="!showBtnSendNow" class="flex items-center">
                            <i class="vc-icon-schedule-calendar icon-xl text-primary ml-2"/>
                            <span class="px-2 my-auto whitespace-nowrap main-text-color">
                                {{ triggerSchedule }}
                            </span>
                        </span>
                        <!-- <base-button v-if="showBtnSendNow" type="primary" size="xs" class="min-w-36 h-7" outline @click="onSendNow">
                            <i class="vc-icon-skip-arrow icon-md mx-2"/>
                            {{ $t('report.schedules.sendNow') }}
                        </base-button> -->
                    </div>
                    <div v-if="actionsWithSchedule" class="flex w-1/3 items-center justify-end">
                        <i class="vc-icon-edit-pencil text-primary cursor-pointer mx-1" @click="editItem" />
                        <i class="vc-icon-recycle-bin text-red-600 cursor-pointer" @click="initDeleteSchedule" />
                    </div>
                </div>
                <div v-if="showBtnSendNow" class="flex items-center mt-3">
                    <i class="vc-icon-schedule-calendar icon-xl text-primary ml-2"/>
                    <span class="px-2 my-auto whitespace-nowrap main-text-color">
                        {{ triggerSchedule }}
                    </span>
                </div>
            </div>
            <div class="flex w-full mb-4" v-if="isTriggerConditionsAreNotEmpty(get(data, 'ReportTriggerCondition', []))">
                <div class="inline-flex px-2">
                    <i class="vc-icon-filter icon-lg text-primary"/>
                    <span class="mx-2 main-text-color">{{ $t('widget.conditions') }}:</span>
                </div>
                <delimited-list :list="conditionsList" :limit="5" separator=" " :class="$rtl.isRTL ? 'text-right' : ''">
                    <template v-slot:list-item="{item}">
                            <el-tooltip placement="top" :open-delay="200">
                                <div slot="content" v-if="item.ReportTriggerConditionFilter && item.ReportTriggerConditionFilter.length">
                                    <div v-for="(condition, index) in item.ReportTriggerConditionFilter" :key="index" class="text-lg">
                                        {{ condition.ColumnName }}: {{ condition.ConditionFilterColumnName }} {{ condition.ConditionFilterOperatorSymbol }} {{ condition.ConditionFilterValue}}
                                    </div>
                                </div>
                                <div>
                                    <rec-item
                                        type="inactive"
                                        :item="item"
                                        :name="item.WidgetTitle"
                                    />
                                </div>
                            </el-tooltip>
                    </template>
                    <template v-slot:other-icon="{data}">
                        <tag content-class="icon-ellipsis">+ {{ data }}</tag>
                    </template>
                    <template v-slot:other-content="{list}">
                        <div class="max-w-xs">
                            <div v-for="(item, index) in list" :key="index"
                                class="flex-1 items-center justify-start p-1">
                                <el-tooltip placement="right" :open-delay="200">
                                    <div slot="content" v-if="item.ReportTriggerConditionFilter && item.ReportTriggerConditionFilter.length">
                                        <div v-for="(condition, index) in item.ReportTriggerConditionFilter" :key="index" class="text-lg">
                                            {{ condition.ColumnName }}: {{ condition.ConditionFilterColumnName }} {{ condition.ConditionFilterOperatorSymbol}} {{ condition.ConditionFilterValue}}
                                        </div>
                                    </div>
                                    <div>
                                        <tag>
                                            {{ item.WidgetTitle }}
                                        </tag>
                                    </div>
                                </el-tooltip>
                            </div>
                        </div>
                    </template>
                </delimited-list>
            </div>
            <div class="flex w-full">
                <div class="inline-flex px-2">
                    <i class="vc-icon-email-groups icon-lg text-primary"/>
                    <span class="mx-2 main-text-color">{{ $t('report.recipientList') }}:</span>
                </div>
                <div class="flex-grow">
                    <div class="w-full" v-if="get(data, 'ReportRecipient', []).length">
                        <delimited-list :list="data.ReportRecipient" :limit="5" separator=" " :class="$rtl.isRTL ? 'text-right' : ''">
                            <template v-slot:list-item="{item}">
                                <rec-item
                                    type="inactive"
                                    :item="item"
                                    :name="getRecipientName(item)"/>
                            </template>
                            <template v-slot:other-icon="{data}">
                                <tag content-class="icon-ellipsis">+ {{ data }}</tag>
                            </template>
                            <template v-slot:other-content="{list}">
                                <div class="max-w-xs">
                                    <div v-for="(item, index) in list" :key="index"
                                        class="flex-1 items-center justify-start p-1">
                                        <tag type="inactive">
                                            {{ getRecipientName(item) }}
                                        </tag>
                                    </div>
                                </div>
                            </template>
                        </delimited-list>
                    </div>
                    <div v-else>
                        - -
                    </div>
                </div>
            </div>
        </el-card>
        <delete-dialog
            v-if="showDeleteDialog"
            :visible.sync="showDeleteDialog"
            :config="{descriptionIcon: ''}"
            :description="$t('report.deleteReportTriggerConfirmation')"
            @on-close="onCancelDelete"
            @on-cancel="onCancelDelete"
            @on-confirm="deleteScheduleItem"
        />
    </div>
</template>

<script>
import { Card, Tooltip, Notification } from 'element-ui'
import get from 'lodash/get'
import Mustache from 'mustache'
import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'

import RecItem from "@/modules/reports/components/RecItem";
import DelimitedList from "@/modules/reports/components/DelimitedList";
import Tag from "@/modules/reports/components/Tag"
import BaseButton from "@/components/Common/Buttons/BaseButton";
import ButtonIcon from "@/modules/common/components/ButtonIcon";
import DeleteDialog from "@/components/Dialogs/DeleteDialog";

const weekDays = {
    1: 'general.dayOfWeek.sunday',
    2: 'general.dayOfWeek.monday',
    3: 'general.dayOfWeek.tuesday',
    4: 'general.dayOfWeek.wednesday',
    5: 'general.dayOfWeek.thursday',
    6: 'general.dayOfWeek.friday',
    7: 'general.dayOfWeek.saturday'
}

export default {
    name: "schedule-card",
    components: {
        BaseButton,
        [Card.name]: Card,
        ButtonIcon,
        RecItem,
        DelimitedList,
        Tag,
        ScheduleForm: () => import('@/modules/reports/components/schedule/ScheduleForm.vue'),
        DeleteDialog,
        [Tooltip.name]: Tooltip
    },
    props: {
        data: {
            type: Object
        },
        showBtnSendNow: {
            type: Boolean,
            default: false
        },
        actionsWithSchedule: {
            type: Boolean,
            default: false
        },
        index: {
            type: Number,
            default: null
        },
        edit: {
            type: Boolean
        },
        reportData: {
            type: Object,
            default: () => ({})
        },
        create: {
            type: Boolean
        }
    },
    data() {
        return {
            showDeleteDialog: false
        }
    },
    methods: {
        get,
        onSendNow() {
            console.log('Send now')
        },
        getRecipientName(item) {
            if (item.ReportRecipientTypeID === 1) {
                const userItem = this.userEntitiesList.find((user) => {
                    return user.ID === item.RecipientID
                })
                return userItem ? userItem.name : undefined
            } else if (item.ReportRecipientTypeID === 2) {
                const accountItem = this.accountEntitiesList.find((account) => {
                    return account.ID === item.RecipientID
                })
                return accountItem ? accountItem.name : undefined
            } else if (item.ReportRecipientTypeID === 3) {
                return item.Email
            }
        },
        initDeleteSchedule () {
            if (this.edit) {
                this.showDeleteDialog = true
            } else {
                this.deleteScheduleItem()
            }
        },
        deleteScheduleItem () {
            this.$emit('deleteScheduleItem', this.index)
            Notification.success(this.$t('general.notification.success'))
            this.onCancelDelete()
        },
        onCancelDelete () {
            this.showDeleteDialog = false
        },
        isTriggerConditionsAreNotEmpty (data) {
            return data.length && data.every(el => Object.keys(el).length)
        },
        editItem () {
            this.$emit('editItem', {
                index: this.index,
                data: this.dataToEdit
            })
        }
    },
    computed: {
        accountEntitiesList() {
            return this.$store.getters['entities/accountsList']
        },
        userEntitiesList() {
            return this.$store.getters['entities/usersList']
        },
        triggerSchedule() {
            const reportTriggerTypeID = get(this.data, 'ReportTriggerTypeID')
            const reportTriggerTypeName = get(this.data, 'ReportTriggerTypeName')
            const scheduleData = get(this.data, 'ScheduleData')

            const translations = {
                'Interval': 'widget.interval',
                'Daily': 'widget.daily',
                'Monthly': 'widget.monthly'
            }

            let triggerScheduleData = `${this.$t(translations[reportTriggerTypeName])} : `
            if (reportTriggerTypeID === 1) {
                // Interval
                let scheduleDays = []
                const triggerDayOfWeek = get(scheduleData, 'TriggerDayOfWeek', [])
                const triggerInterval = get(scheduleData, 'TriggerInterval')
                const triggerTimeRange = get(scheduleData, 'TriggerTimeRange', {})

                triggerDayOfWeek.forEach(day => {
                    scheduleDays.push(this.$t(weekDays[day]))
                })
                const intervalScheduleDays = scheduleDays.join(', ')

                const intervalScheduleTimeRange = `${this.$t('report.schedules.start')} ${triggerTimeRange.Start}, ` +
                    `${this.$t('report.schedules.end')} ${triggerTimeRange.End}`

                const duration = moment.duration(triggerInterval, 'minutes');
                const hours = Math.floor(duration.asHours())
                const minutes = Math.floor(duration.asMinutes()) - hours * 60
                const seconds = Math.floor(duration.asSeconds()) - Math.floor(duration.asMinutes()) * 60

                const intervalScheduleTime = `${this.$t('report.schedules.every')} ${hours}h:${minutes}m:${seconds}s`
                triggerScheduleData += [intervalScheduleDays, intervalScheduleTimeRange, intervalScheduleTime].join(', ')
            } else if (reportTriggerTypeID === 2) {
                // Daily
                const triggerDays = get(scheduleData, 'TriggerDayOfWeek', [])
                const triggerTime = get(scheduleData, 'TriggerTime')

                let scheduleDays = []
                triggerDays.forEach(day => {
                    scheduleDays.push(this.$t(weekDays[day]))
                })

                const dailyTriggerDays = scheduleDays.join(', ')
                const dailyTriggerTime = `${this.$t('report.schedules.time')} ${triggerTime}`

                triggerScheduleData += [dailyTriggerDays, dailyTriggerTime].join(', ')
            } else if (reportTriggerTypeID === 3) {
                // Monthly
                const triggerDayOfMonth = get(scheduleData, 'TriggerDayOfMonth', []).join(', ')
                const triggerTime = get(scheduleData, 'TriggerTime')

                const monthlyDaysOfMonth = `${this.$t('report.schedules.daysOfTheMonth')} ${triggerDayOfMonth}`
                const monthlyTriggerTime = `${this.$t('report.schedules.at')} ${triggerTime}`

                triggerScheduleData += [monthlyDaysOfMonth, monthlyTriggerTime].join(' ')
            }

            return triggerScheduleData
        },
        conditionsList() {
            const conditions = get(this.data, 'ReportTriggerCondition', [])
            const isConditionsIsNotEmpty = conditions.every(el => {
                return Object.keys(el).length
            })
            if (!conditions.length || !isConditionsIsNotEmpty) {
                return false
            }
            return conditions.map(el => {
                el.ReportTriggerConditionFilter = el.ReportTriggerConditionFilter.map(condition => {
                    const findWidgetById = this.reportData.ReportItemList.find(item => item.WidgetID === condition.WidgetID)
                    let findWidgetColumnListByWidgetId = null

                    if (findWidgetById) {
                        el.WidgetTitle = findWidgetById.WidgetTitle
                        findWidgetColumnListByWidgetId = this.widgetTemplateList.find(widget => widget.WidgetTemplateID === findWidgetById.WidgetTemplateID)
                    }

                    if (!('ConditionFilterColumnName' in condition)) {
                        condition.ConditionFilterColumnName = this.conditionFilterColumnTypeList.find(el => el.ConditionFilterColumnTypeID === condition.ConditionFilterColumnTypeID).ConditionFilterColumnName
                    }

                    if (findWidgetColumnListByWidgetId) {
                        const widgetTemplateColumn = findWidgetColumnListByWidgetId.WidgetTemplateColumnList.find(column => column.WidgetTemplateColumnsID === condition.WidgetTemplateColumnID)
                        if (widgetTemplateColumn) {
                            condition.ColumnName = widgetTemplateColumn.WidgetTemplateColumnsName
                            if (!('ConditionFilterOperatorSymbol' in condition)) {
                                condition.ConditionFilterOperatorSymbol = widgetTemplateColumn.WidgetTemplateColumnOperatorList.find(el => el.ConditionFilterOperatorID === condition.ConditionFilterOperatorID).ConditionFilterOperatorSymbol
                            }
                        }
                    }
                    return condition
                })
                return el
            })
        },
        dataToEdit () {
            const reportTriggerData = cloneDeep(this.reportData.ReportTriggerList[this.index])
            if ('TriggerTimeRange' in reportTriggerData.ScheduleData) {
                const startTime = reportTriggerData.ScheduleData.TriggerTimeRange.Start
                const endTime = reportTriggerData.ScheduleData.TriggerTimeRange.End
                reportTriggerData.ScheduleData.TriggerTimeRange = [startTime, endTime]
            }
            return {
                reportTriggerData: reportTriggerData,
                indexToEdit: this.index
            }
        },
        getConfData () {
            return this.$store.getters['reportTrigger/getConfData']
        },
        widgetTemplateList () {
            return this.getConfData.WidgetTemplateList
        },
        conditionFilterColumnTypeList () {
            return this.getConfData.ConditionFilterColumnTypeList
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-card {
    background: var(--mainBgColor-color) !important;
}
</style>
